import { render, staticRenderFns } from "./DuplicateEvent.vue?vue&type=template&id=c872e35a"
import script from "./DuplicateEvent.vue?vue&type=script&lang=js"
export * from "./DuplicateEvent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports